<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo-->
    <a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
    </a>
    <!-- /Brand logo-->
    <!-- Left Text-->
    <div class="d-none d-md-flex d-lg-flex col-xl-8 col-lg-7 align-items-center p-5 p-md-0">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5 px-md-0">
        <img src="assets/images/pages/login-illustration.svg" *ngIf="coreConfig.layout.skin !== 'dark'" alt="" />
        <img src="assets/images/pages/login-illustration-dark.svg" *ngIf="coreConfig.layout.skin === 'dark'" alt="" />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Login-->

    <div class="d-flex col-xl-4 col-lg-5 col-md-12 align-items-center justify-content-center px-2 p-lg-5">
      <!-- Maintenance card -->
      <div class="col-12">
        <h2 class="card-title font-weight-bold mb-1" *ngIf="!isMaintenance">{{ "WELCOME" | translate }} 👋</h2>
        <p class="card-text mb-2" *ngIf="!isMaintenance">{{ "LOGIN_MESSAGE_WELCOME" | translate }}</p>
        <div class="row">
          <div class="col-12" *ngIf="isMaintenance">
            <div class="card">
              <div class="card-body py-4">
                <h2 class="text-center">🚧 {{ "MAINTENANCE" | translate }}</h2>
                <p class="my-2 card-text font-medium-2 text-center">{{'PLATFORM_MAINTENACE_LOGIN_MESSAGE' | translate}}
                  {{this.options.maintenance_start | date: 'HH:mm'}}
                  {{'HOUR_TO' | translate | lowercase }}
                  {{this.options.maintenance_end | date: 'HH:mm'}}.<br />
                  {{ "PLATFORM_MAINTENACE_LOGIN_MESSAGE_CONCLUSION" | translate }}
                </p>
                <div class="d-flex justify-content-center align-items-center">
                  <img class="mr-025" src="assets/images/logo/nepta-icon.svg" alt="Nepta" width="25" />
                  <p class="font-weight-bolder mb-0">{{ "DEVELOPER_TEAM" | translate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isDevMode()" class="my-2">
          <select class="form-control" #userForLogin (change)="autoLogin(userForLogin.value)">
            <option value="-">Seleziona utenza</option>
            <option value="super-admin">Nepta Administrator (direzione)</option>
            <option value="direzione">Matteo Candura (direzione)</option>
            <option value="amministrazione">Giacomo Mansi (amministrazione)</option>
            <option value="hr">Davide Procaccini (HR)</option>
            <option value="commerciale">Flavia Pisani (commerciale)</option>
            <option value="supporto-asset">Ludovica Lombardi (Supporto Asset)</option>
            <option value="supporto-piattaforma">Emilio Salarini (Supporto piattaforma)</option>
            <option value="recruiting">Lina Cattaneo (recruiting)</option>
            <option value="employee1">Mario Rossi (dipendente)</option>
          </select>
        </div>
        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p *ngIf="error === 'Invalid email'">{{ "INVALID_EMAIL" | translate }}</p>
            <p *ngIf="error === 'Platform in maintenance mode'">{{ "PLATFORM_IN_MAINTENANCE" | translate }}</p>
            <p *ngIf="error === 'Wrong email address'">{{ "INVALID_EMAIL_ADDRESS" | translate }}</p>
            <p *ngIf="error === 'Wrong password'">{{ "INVALID_PASSWORD" | translate }}</p>
            <p *ngIf="error === 'Unknown Error'">{{ "ERROR_CONNECTION" | translate }}</p>
            <p *ngIf="error !== 'Platform in maintenance mode' && error !== 'Invalid email' && error !== 'Wrong email address' && error !== 'Wrong password' && error !== 'Unknown Error' && error !== 'Invalid email'">
              {{ "GENERIC_ERROR" | translate }}
            </p>
          </div>
        </ngb-alert>
        <form class="auth-login-form mt-2" *ngIf="!isMaintenance" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label class="form-label" for="login-email">{{ "EMAIL" | translate }}</label>
            <input
              type="text"
              [formControlName]="'email'"
              id="login-email"
              class="form-control"
              autofocus=""
              tabindex="1"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
              placeholder="n.cognome@nepta.it"
              aria-describedby="login-email"
            />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">{{ "EMAIL_REQUIRED" | translate }}</div>
              <div *ngIf="f.email.errors.email">{{ "EMAIL_NOT_VALID" | translate }}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <label>Password</label>
              <div class="cursor-pointer text-primary" (click)="modalOpen(requirePassword)">
                <small>{{ "FORGOTTEN_PASSWORD" | translate }}</small>
              </div>
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                [formControlName]="'password'"
                class="form-control form-control-merge"
                [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                placeholder="············"
                aria-describedby="login-password"
                tabindex="2"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer">
                  <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': passwordTextType, 'icon-eye': !passwordTextType }" (click)="togglePasswordTextType()"></i>
                </span>
              </div>
            </div>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && f.password.errors }">
              <div *ngIf="f.password.errors.required">{{ "PASSWORD_IS_REQUIRED" | translate }}</div>
            </div>
          </div>
          <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4"><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>{{ "SIGN_IN" | translate }}</button>
        </form>
        <p *ngIf="isMaintenance" class="text-center">v. {{ getVersion() }}</p>
        <p *ngIf="!isMaintenance" class="float-md-right mt-4">v. {{ getVersion() }}</p>
      </div>
    </div>

    <!-- /Login-->
  </div>
</div>
<!-- Modal Add -->
<ng-template #requirePassword let-modal>
  <div>
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "REQUEST_RESET_PASSWORD" | translate }}</h3>
      <p>{{ "MESSAGE_RESET_PASSWORD" | translate }}</p>
      <label [for]="'requireEmail'">{{ "EMAIL" | translate }}<sup class="text-danger">*</sup></label>
      <input [(ngModel)]="sendPasswordResetTo" name="requireEmail" type="email" maxlength="255" [id]="'requireEmail'" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button [disabled]="sendPasswordResetTo.length < 5 || !sendPasswordResetTo.includes('@')" type="submit" class="btn btn-primary w-150" rippleEffect (click)="requireNewPassword(); modal.close()">
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / Modal Add -->
